var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { display: "flex", "align-items": "center" } },
    [
      Boolean(_vm.content)
        ? _c(
            "el-tooltip",
            { attrs: { content: _vm.content, placement: "right-end" } },
            [_c("i", { staticClass: "el-icon-warning red" })]
          )
        : _vm._e(),
      _c("div", { staticStyle: { flex: "1" } }, [_vm._t("default")], 2)
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }